export default __webpack_public_path__ + "static/media/icon2@3x_.6ad30357.png";